export type McpTool = { name: string; description: string };

export const MCP_ENV_VARS = [
  { name: 'CASSETTE_API_URL', required: false, description: 'Backend URL (default: http://localhost:8080)' },
  { name: 'CASSETTE_API_TOKEN', required: true, description: 'Personal access token (ct_live_…)' },
  { name: 'CASSETTE_PRODUCT', required: false, description: 'music, creator, or both (default: both)' },
] as const;

/** Prerequisites for musicians: account check and Drive linking before uploads. */
export const MCP_SHARED_TOOLS: McpTool[] = [
  { name: 'cassette_get_account', description: 'Profile, Drive link status, and subscription tier' },
  { name: 'cassette_start_gdrive_link', description: 'OAuth URL to link Google Drive (required for uploads)' },
];

/** Full track creation workflow for musicians — create, upload assets, metadata, verify. */
export const MCP_MUSIC_TOOLS: McpTool[] = [
  { name: 'cassette_create_track', description: 'Create a new track (name + artist)' },
  { name: 'cassette_upload_track_file', description: 'Upload artwork, audio, promo, footages, or vertical videos' },
  { name: 'cassette_update_track_metadata', description: 'pitchEn, pitchNative, notes, status, progress, multilink, name, artist' },
  { name: 'cassette_list_track_files', description: 'List uploaded files by category' },
  { name: 'cassette_get_track', description: 'Get full track state after creation' },
];

export const MCP_CREATOR_TOOLS: McpTool[] = [
  { name: 'cassette_get_creator_billing', description: 'Tier, limits, clip count' },
  { name: 'cassette_list_clips', description: 'List clips' },
  { name: 'cassette_get_clip', description: 'Get clip by ID' },
  { name: 'cassette_create_clip', description: 'Create clip' },
  { name: 'cassette_update_clip', description: 'Update clip' },
  { name: 'cassette_delete_clip', description: 'Delete clip' },
  { name: 'cassette_update_scenario', description: 'Scenario time blocks' },
  { name: 'cassette_update_clip_notes', description: 'Freeform notes' },
  { name: 'cassette_list_trends', description: 'Trend library' },
  { name: 'cassette_create_trend', description: 'Save a trend link' },
  { name: 'cassette_delete_trend', description: 'Delete a trend' },
  { name: 'cassette_start_clip_from_trend', description: 'New clip from trend' },
  { name: 'cassette_list_footages', description: 'List footages' },
  { name: 'cassette_upload_footage', description: 'Upload footage file' },
  { name: 'cassette_review_footage', description: 'Star and note footages' },
  { name: 'cassette_delete_footage', description: 'Delete footage' },
  { name: 'cassette_get_final', description: 'Get final video' },
  { name: 'cassette_upload_final', description: 'Upload final video' },
  { name: 'cassette_update_post_links', description: 'TikTok, Reels, Shorts, VK links' },
  { name: 'cassette_manage_clip_shares', description: 'Clip collaboration' },
];

export const MCP_SCOPES = [
  { scope: 'music:read', access: 'GET on /tracks/*' },
  { scope: 'music:write', access: 'Mutations on /tracks/*' },
  { scope: 'creator:read', access: 'GET on /creator/*' },
  { scope: 'creator:write', access: 'Mutations on /creator/*' },
] as const;

export const MCP_PLACEHOLDER_TOKEN = 'ct_live_YOUR_TOKEN_HERE';

export const MCP_PACKAGE_NAME = '@cassette.diy/mcp';
export const MCP_NPM_URL = 'https://www.npmjs.com/package/@cassette.diy/mcp';
export const MCP_REPO_URL = 'https://github.com/cassette-music-management-tool/cassette-mcp';
